<div class="thank-you-popup" [class.show]="isShow">
  <div class="popup-background">
    <i class="icon icon-mail-big"></i>
    <div class="thank-you">Sikeres regisztráció, köszönjük jelentkezését!</div>
    <a [routerLink]="'/'" class="button button-primary" [appBackgroundColor]="'red'">Vissza a főoldalra</a>
  </div>
</div>
